<template>
  <v-app>
    <v-row class="px-4">
      <LoadingDialog v-if="loading" 
      :is_loading=loading />
      <v-col cols="12">
        <v-card 
          v-if="!loading" 
          elevation="0" 
          style="margin-top: 15px;">
          <v-card-title>
            <v-row>
              <v-col cols="4">
                {{ $t('_module_expert_incident_') }}
              </v-col>
              <v-col cols="3" offset="5">
                <dates-selector
                      :store_date="$store.getters.niv2Dates"
                      :min_date="auditDates.start"
                      :max_date="auditDates.end"
                      :show_label="false"
                      :default_last_month="false"
                      store_cal_event="SET_NIV2_CALENDAR_REFRESH"
                      store_date_commit="SET_NIV2_DATES"
                />
                <slot></slot>
              </v-col>
            </v-row>


          </v-card-title>
        </v-card>
        <v-card 
          v-if="!loading" 
          elevation="0">

          <v-card-text class="main-template"> 

            <v-row class="mb-4">
              <v-col cols="3">
                <tree-select
                  style='height: 50px'
                  v-model="pdm_values"
                  :auto-load-root-options=false
                  :defaultExpandLevel="expand_level"
                  :disable-branch-nodes=false
                  :load-options="getAllPdmTree"
                  :multiple=true
                  :options="ts_options"                 
                  :showCount=true
                  :limit="1"                  
                  :value-consists-of="'ALL'"
                  :placeholder="$t('_point(s)_de_mesure_')"
                  v-on:input="select_pdm_value(pdm_values)" 
                >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel }}</div>
                </tree-select>
              </v-col>

              <v-col cols="3">
                <v-select
                  v-model="min_perimeter_value"
                  :label="$t('_perimetre_minimum_')"
                  :items="min_perimeter"
                  @change="select_value_min_parimeter"
                  dense
                ></v-select>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col cols="3">
                <v-select
                  v-model="incident_type_value"
                  :label="$t('_type_d_incident_')"
                  :items="incident_type"
                  @change ="select_value_incident_type"
                  dense
                  multiple
                  clearable
                >             
                
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item["text"] }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="grey--text text-caption"
                  >
                    (+{{ incident_type_value.length -1}} others)
                  </span>
                </template>
                <v-list-item
                   slot="prepend-item"
                   ripple
                   @click="toggle"
                    >   
                    <v-list-item-action>
                   <v-icon :color="incident_type_value.length > 0 ? 'indigo darken-3' : ''">{{ icon }}</v-icon>
                   </v-list-item-action>
                    <v-list-item-title> {{$t("_select_all_")}}</v-list-item-title>
                   </v-list-item>
                   <v-divider
                   slot="prepend-item"
                   class="mt-2"
                     />  
                              
                    </v-select>
                  </v-col>
              <v-col cols="3">
                <v-select
                  v-model="min_duration_incident_value"
                  :label="$t('_duree_minimale_d_incident_')"
                  :items="min_duration_incident"
                  @change="select_value_min_duration"                                    
                  dense
                >
                </v-select>
              </v-col>

              <v-col cols="3">
                <v-select
                  v-model="nb_incident_value"
                  :label="$t('_nombre_d_incidents_affiches_')"
                  :items="nb_incident"
                  @change="select_value_nb_incident" 
                  dense
                ></v-select>
              </v-col>
            
              <v-col cols="3">
                <v-text-field
                  v-model="irradiantion_value"
                  :label="$t('_irradiation_min_si_courte_duree_(W/m2)_')"
                  @change="select_irradiantion_value" 
                  type="number"
                  dense
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="2" offset="9">
                <v-btn @click="actualize_data()">{{$t("_actualiser_")}}</v-btn>
              </v-col>
            </v-row> 

            <v-row >
                <v-data-table
                :items="incidentData"
                :headers="headers_values" 
                :footer-props="{
                    'items-per-page-options': [20, 50, 100, -1],
                    'items-per-page-text': this.$t('_lignes_par_page_'),           
                  }"              
                 class="elevation-1">
                </v-data-table>
            </v-row>

            <v-row>
              <v-btn @click="download_data()">{{$t("_telecharger_les_donnees_")}}</v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
  import DatesSelector from "@/components/Utils/DatesSelector";
  import LoadingDialog from "@/components/Utils/LoadingDialog";
  import "leaflet/dist/leaflet.css";
  import api from "@/api/api"
  import TreeSelect from '@riophae/vue-treeselect';
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  //import cd from '@/utils/compute_data.js';
   
  export default {
    components: {
      LoadingDialog,
      DatesSelector,
      TreeSelect
    },

    //Initialize all value for the view
    mounted() {
      this.actualize_data()
    },

    data() {
      return {         
        incidentData : [],
        headerData :[],
        table_data_qry: null,
        category_table_data:null,
        expand_level: 0,       
        min_perimeter:[],  
        incident_type:[],
        min_duration_incident:[],    
        nb_incident:[],
        headers_values: [],        
        installation_id: this.$route.params.id,
        ts_options : [],
        loading : false,        
        pdm:"",
        current_pdm_value:"",
        min_perimeter_value : "",
        incident_type_value : [],
        incident_type_api_value : "",
        min_duration_incident_value : "",
        nb_incident_value : "",
        irradiantion_value : 50,
      }
      
    },

    computed: {
      installation() {
        return this.$store.getters.installations.find(
          (x) => x.id == this.installation_id
        );
      },

      auditDates() {
      return this.$store.state.parametersStore.dates
    },
      dates() {
        return this.$store.state.parametersStore.dates
    },
    selectAllincident(){
        return this.incident_type_value.length===this.incident_type.length

    },
    icon () {
    if (this.selectAllincident) return 'mdi-close-box'    
    return 'mdi-checkbox-blank-outline'
  },
    },

    watch: {
      '$route': {
        async handler() {          
          //this.refresHeader()
          await this.getAllPdmTree() 
          await this.refresh_incident_type()
          await this.refresh_header_values()           
          await this.actualize_data()

        },
        immediate: true,
      },

      '$root.$i18n.locale': {
        async handler() {
          console.log('$root.$i18n.locale')         
          await this.refresh_incident_type()
          await this.refresh_header_values()
          await this.getAllPdmTree() 
          await this.actualize_data()
        },
        immediate: true,
      },

      async '$store.getters.niv2CalendarRefresh'() {
      if (this.$store.getters.niv2CalendarRefresh) {
        this.$store.commit('SET_NIV2_CALENDAR_REFRESH', false)
        
      }
     },
    },
    methods: {
      toggle(){
        {
        if (this.selectAllincident) {
          this.incident_type_value = []
        } else {
          this.incident_type_value = this.incident_type.slice()
        }
      }
    },   
      
      select_pdm_value(pdm) {             
        this.current_pdm_value=''   
        if (pdm === undefined || pdm === null || pdm.length === 0){
          this.current_pdm_value = ''
        }        
        else{          
          for(let x in pdm)
        { 
          
          if(pdm[x].length<10)
        {
          continue
        }
          for(let i in pdm[x])
            {            
              if(i>=10)
            {
             
              this.current_pdm_value+=pdm[x][i]
            }
            
            }            
            this.current_pdm_value +=',' 
           
          }            
       
      }
       
      },

      select_value_incident_type(){
        this.incident_type_api_value=''
        if (this.incident_type_value === undefined || this.incident_type_value === null || this.incident_type_value.length === 0){
          this.incident_type_api_value = ''         
        }
        else{
          for(let i in this.incident_type_value)
        {
          this.incident_type_api_value += this.incident_type_value[i] +','
          
        }
        }        
       
      },


      select_value_min_duration(){
        this.min_duration_incident=[
          {
            text: this.$t("_>_2_pas_de_temps_"),
            value:"0.5 Heure"
          },
          {
            text: this.$t("_>_1_heures_"),
            value: "1 Heures"
          },
          {
            text: this.$t("_>_2_heures_"),
            value: "2 Heures"
          },
          {
            text: this.$t("_>_4_heures_"),
            value: "4 Heures"
          },
          {
            text: this.$t("_>_1_journée_"),
            value: "24 Heures"
          },
          {
            text: this.$t("_>_2_journées_"),
            value: "48 Heures"
          }
        ]    
        if (this.min_duration_incident_value === undefined || this.min_duration_incident_value === null || this.min_duration_incident_value.length === 0){
          this.min_duration_incident_value = '0.5 Heure'
        }
        else{
          this.min_duration_incident_value =this.min_duration_incident_value
        }

      },

      refresh_header_values(){
        this.headers_values= [
          {
            text: this.$t("_incident_type_"),
            value:"incident_type"
          },
          {
            text: this.$t("_point_de_mesure_"),
            value: "mesurement_point"
          },
          {
            text: this.$t("_incident_perimetre_"),
            value: "incident_perimeter"
          },
          {
            text: this.$t("_start_hour_date_"),
            value: "start_hour_date"
          },
          {
            text: this.$t("_end_hour_date_"),
            value: "end_hour_date"
          },
          {
            text: this.$t("_incident_duree_"),
            value: "incident_time"
          },
          {
            text: this.$t("_pertes_pdm_kwh_"),
            value: "pdm_losses_kwh"
          },
          {
            text: this.$t("_pertes_pdm_currency_"),
            value: "pdm_losses_currency"
          },
          {
            text: this.$t("_pertes_pdm_frac_eac_sim_pdm_"),
            value: "pdm_losses_waiting"
          },
          {
            text: this.$t("_pertes_pdm_frac_eac_sim_site_"),
            value: "pdm_losses_waiting_site"
          },
          {
            text: this.$t("_pertes_perimetre_kwh_"),
            value: "perimeter_losses"
          }
        ]           

      },

      refresh_incident_type(){
        this.incident_type=[
          {
            text: this.$t("_arret_voc_"),
            value:"voc downtime"
          },
          {
            text: this.$t("_autres_arrets_"),
            value: "other downtime"
          },
          {
            text: this.$t("_donnees_manquantes_"),
            value: "missing data"
          },
          {
            text: this.$t("_donnees_figees_"),
            value: "frozen data"
          },
          {
            text: this.$t("_chaines_deconnectees_"),
            value: "disconnected strings"
          },
          {
            text: this.$t("_ecretage_en_intensite_"),
            value: "current clipping"
          },
          {
            text: this.$t("_clipping_vmin_"),
            value: "clipping (mppt range) vmin"
          },
          {
            text: this.$t("_clipping_vmax_"),
            value: "clipping (mppt range) vmax"
          },
          // {
          //   text: this.$t("_ecretage_en_pdc_"),
          //   value: "clipping_pmax_dc"
          // },          
          {
             text: this.$t("_ecretage_en_pac_"),
             value: "ac power clipping"
          },
          // {
          //   text: this.$t("_neige_"),
          //   value: "snow"
          // },
          // {
          //   text: this.$t("_derating_"),
          //   value: "derating"
          // },
          {
            text: this.$t("_surperte_conversion_>_2%_"),
            value: "ac-dc conversion overlosses > 2%"
          },
          // {
          //   text: this.$t("_activations_intermittentes_diodes_"),
          //   value: "perimeter_losses"
          // },
          // {
          //   text: this.$t("_evenement_o&m_-_1_"),
          //   value: "om_incident_1"
          // },
          // {
          //   text: this.$t("_evenement_o&m_-_2_"),
          //   value: "om_incident_2"
          // },
          // {
          //   text: this.$t("_evenement_o&m_-_3_"),
          //   value: "om_incident_3"
          // },
          // {
          //   text: this.$t("_consignes_reseaux_"),
          //   value: "curtailment"
          // },
          // {
          //   text: this.$t("_facteur_limitant_inconnu_"),
          //   value: "unknown_factor"
          // },
          // {
          //   text: this.$t("_surchauffe_champ_pv_"),
          //   value: "overheat_pv"
          // },
          {
            text: this.$t("_ombrage_"),
            value: "shading"
          }

        ] 

      },
      select_value_min_parimeter(){
        this.min_perimeter=[           
            {
            text: this.$t("_site_"),
            value:"0"
          },
          {
            text: this.$t("_site_/_onduleur_"),
            value: "1"
          },
          {
            text: this.$t("_site_/_onduleur_/_pdm_"),
            value: "2"
          }
          ]
        if (this.min_perimeter_value === undefined || this.min_perimeter_value === null || this.min_perimeter_value.length === 0){
          this.min_perimeter_value = '2'
        }        
        else{
          this.min_perimeter_value=this.min_perimeter_value
        }  
       
      },
      select_value_nb_incident(){
        this.nb_incident=[
          {
            text: this.$t("_top_15_"),
            value:"Top 15"
          },
          {
            text: this.$t("_top_50_"),
            value: "Top 50"
          },
          {
            text: this.$t("_top_100_"),
            value: "Top 100"
          },
          {
            text: this.$t("_top_250_"),
            value: "Top 250"
          }
        ]
        if (this.nb_incident_value === undefined || this.nb_incident_value === null || this.nb_incident_value.length === 0){
          this.nb_incident_value = 'Top 15'
        }
        else
        {
          this.nb_incident_value =this.nb_incident_value
          
        }
        
      },
      select_irradiantion_value(){
        if (this.irradiantion_value === undefined || this.irradiantion_value === null || this.irradiantion_value.length === 0){
          this.irradiantion_value = 50
        }
        else
        {
          this.irradiantion_value =this.irradiantion_value
        
        }
        
      },

      async getAllPdmTree() {
        const langcode = this.$root.$i18n.locale

        await api
          .getPdmTree(this.installation_id, langcode)
          .then((res) => {
            this.ts_options = []
            res.data['tree'].map((elm) => this.ts_options.push(elm));
            this.expand_level = res.data['expand_level']
          });
      },

      async actualize_data(){  
        this.loading = true  
        this.select_value_min_parimeter()
        this.select_value_nb_incident()
        this.select_value_min_duration()
        this.select_value_incident_type()
        this.select_irradiantion_value()
        this.incidentData =[]       
        
        if(this.selectAllincident)
        {
          this.incident_type_api_value =''
          
        }      
        try {
            const { data } = await api.getIncidentTable(this.$route.params.id, {
              start_date: this.$store.getters.niv2Dates.start,
              end_date: this.$store.getters.niv2Dates.end,
              incident_list: this.incident_type_api_value,
              pdm_list: this.current_pdm_value,
              min_irradiance: this.irradiantion_value,
              nb_incidents: this.nb_incident_value,
              max_perimeter: this.min_perimeter_value,
              min_duration: this.min_duration_incident_value,
              country_lang_code: this.$root.$i18n.locale,
              pacgrid: this.installation.elec_var.includes("Pac@grid")
            });
            
            if (data.data && Array.isArray(data.data)) {
            this.table_data_qry = data;       
            this.category_table_data = data.data;
            this.incidentData = this.category_table_data.map((data) => {
                let data_item = {};                
                this.headers_values.forEach(({ value }) => {                  
                    if (data[value] !== undefined) data_item[value] = data[value];
                });
                //console.log('Processed Data Item:', data_item); // Checking each processed data item               
                return data_item;
            });
             
          } else {
            console.error('Invalid data structure:', data.data);
        }
          } catch (error) {
            console.error('Error fetching data:', error);
          }
          finally {
        this.loading = false; // Reset loading state
    }
		},   
     
      download_data(){
        this.headerData=[]
    
        
        for (let i = 0; i < this.headers_values.length; i++) {
           if (this.headers_values[i].text) {
             this.headerData.push({'text_' : this.headers_values[i].text , 'value':this.headers_values[i].value})
           }
          }
         
        api.convertJsonIncident({"data": {"input":this.table_data_qry},  "header": this.headerData}, "xlsx",this.$root.$i18n.locale,"data_table")
        .then((res)=>{
          let name = this.$t("_module_expert_incident_")+ this.$route.params.id + ".xlsx"
          let a = document.createElement('a');
          a.href = URL.createObjectURL(res.data) ;
          a.download = name;
          a.click();
        })
        
        // console.log(this.headerData)
      }

    },
  };
</script>

<style scoped>
  .v-select-like {
    border: 1px solid black !important;
    width: 100vw;
    display: block;
    border-radius: 4px;
    outline: none;
    color: black;
  }

  .vue-treeselect {
    font-size: 0.9rem;
    font-weight: normal;
  }

  .v-card__subtitle,
  .v-card__text,
  .v-card__title {
    padding: 16px 16px 16px 16px;
    border-bottom: #eee solid 1px;
  }

  html {
    overflow: hidden !important;
  }

  .v-card{
    padding: 16px 16px 16px 16px !important
  }

</style>
